"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagManager = void 0;
const launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
class FlagManager {
    constructor({ showLog }) {
        this.listeners = new Map();
        /**
         *
         *
         * @param {(featureName: string, value: boolean) => void} onFeatureFlagChange
         * @memberof FlagManager
         * listen to feature flag change
         * return: unlisten function
         */
        this.listen = (onFeatureFlagChange) => {
            this.listeners.set(onFeatureFlagChange, onFeatureFlagChange);
            return () => this.listeners.delete(onFeatureFlagChange);
        };
        this.removeAllListeners = () => {
            this.listeners.clear();
        };
        this.identifyUser = (userId, payload) => {
            if (this.lastIdentifiedUserId === userId)
                return;
            FlagManager.ldClient
                ?.identify({
                kind: "user",
                key: userId,
                ...payload,
            })
                .then(() => {
                this.lastIdentifiedUserId = userId;
            })
                .catch((err) => {
                this.showLog && console.error(err);
            });
        };
        this.waitUntilReady = async () => {
            await FlagManager.ldClient
                ?.waitUntilReady()
                .catch((err) => this.showLog && console.error(err));
        };
        this.prepareFeatureSwitches = (defaultFS) => {
            if (!FlagManager.ldClient)
                return {};
            const res = {};
            Object.keys(defaultFS).forEach((key) => {
                res[key] = FlagManager.ldClient.variation(key, defaultFS[key]);
            });
            return res;
        };
        this.onLDFlagChange = (payload) => {
            const flagValues = Object.entries(payload).reduce((prev, [key, value]) => ({ ...prev, [key]: value.current }), {});
            this.listeners.forEach((listener) => listener(flagValues));
        };
        this.startListening = () => {
            FlagManager.ldClient?.on("change", this.onLDFlagChange);
            return () => {
                FlagManager.ldClient?.off("change", this.onLDFlagChange);
            };
        };
        this.showLog = showLog;
    }
    static init(clientSideKey, option, ldOptions, userIdentifier) {
        const user = {
            kind: "user",
            key: userIdentifier || "not_provided",
        };
        const options = {
            bootstrap: "localStorage",
            privateAttributes: ["role", "userRoles", "email"],
            ...ldOptions,
        };
        const client = launchdarkly_js_client_sdk_1.initialize(clientSideKey, user, options);
        FlagManager.ldClient = client;
        return new FlagManager(option);
    }
}
exports.FlagManager = FlagManager;
FlagManager.featureSwitches = {};
FlagManager.setFeatureSwitches = (fs) => {
    FlagManager.featureSwitches = {
        ...FlagManager.featureSwitches,
        ...fs,
    };
};
